import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/jenkins/workspace/prod/rollback-frontend/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManagerInitiator"] */ "/home/jenkins/workspace/prod/rollback-frontend/src/components/GoogleTagManagerInitiator/GoogleTagManagerInitiator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/jenkins/workspace/prod/rollback-frontend/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/prod/rollback-frontend/src/hocs/TranslationsProvider/TranslationsProvider.js");
